exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".estado-borrador[data-v-8d9fc2fe]{border-radius:15px;color:#fff!important;background:#ce7d00;margin:10px;padding:10px 30px}.estado-noCreado[data-v-8d9fc2fe]{border-radius:15px;color:#fff!important;background:#ce1f00;margin:15px;padding-left:15px;padding-right:15px}.estado-publicado[data-v-8d9fc2fe]{border-radius:15px;color:#fff!important;background:#16bc0c;margin:10px;padding:10px 30px}.img-categoria[data-v-8d9fc2fe]{width:200px}@media screen and (max-width:600px){.img-categoria[data-v-8d9fc2fe]{width:100px}.categoria[data-v-8d9fc2fe]{width:120px}.texto-car-categoria[data-v-8d9fc2fe]{font-size:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d9fc2fe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/categories/Category.vue
// module id = 410
// module chunks = 0